<template>
	<router-view>
	</router-view>
</template>

<script>
	export default {
		name: "AgencyContestActionTemplate",
	};
</script>

<style scoped>

</style>
